import ApolloClient from 'apollo-boost'
import { InMemoryCache } from 'apollo-cache-inmemory'
import fetch from 'cross-fetch'
import { Shops } from '../../interfaces'
import { ApolloClientCollectionItem } from './shopConfigLoader.types'

export class ApolloClientFactory {
  private cachedClients: ApolloClientCollectionItem[] | null = null

  constructor(private graphqlUri: string, private shops: Shops[]) {}

  create(): ApolloClientCollectionItem[] {
    // Return cached clients - create Apollo clients ONCE, not per request!
    // Memory leak fix: Apollo InMemoryCache must be reused, not recreated
    if (this.cachedClients) {
      return this.cachedClients
    }

    this.cachedClients = this.shops.map((shop) => {
      return {
        client: new ApolloClient<InMemoryCache>({
          fetch: fetch as any,
          cache: new InMemoryCache(),
          headers: {
            'x-shop-id': shop,
          },
          uri: this.graphqlUri,
        }),
        shop,
      }
    })

    return this.cachedClients
  }
}
